"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("./../../Box"));
var _tokens = require("./../../styles/tokens");
// This returns an li element, that is rendered within the popup combo-box in Autocomplete.
// https://mui.com/material-ui/api/autocomplete/#autocomplete-prop-renderOption
var renderOptionsWithIcons = function renderOptionsWithIcons(_ref) {
  var _option$label;
  var props = _ref.props,
    option = _ref.option,
    ownerState = _ref.ownerState,
    OptionStartIconComponent = _ref.OptionStartIconComponent,
    OptionEndIconComponent = _ref.OptionEndIconComponent;
  var hasIconsToRender = OptionStartIconComponent || OptionEndIconComponent || option.startIconComponent || option.endIconComponent;
  return /*#__PURE__*/_react.default.createElement(_Box.default, (0, _extends2.default)({
    component: "li"
  }, props, {
    sx: {
      display: 'flex',
      gap: _tokens.spacing40,
      alignItems: 'center'
    }
  }), hasIconsToRender ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, option.startIconComponent || OptionStartIconComponent, /*#__PURE__*/_react.default.createElement(_Box.default, {
    component: "span",
    sx: {
      flex: '1 auto'
    }
  }, ownerState && ownerState.getOptionLabel(option), !ownerState && option.label), option.endIconComponent || OptionEndIconComponent) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ownerState && ownerState.getOptionLabel(option), !ownerState && ((_option$label = option.label) != null ? _option$label : option)));
};
var _default = exports.default = renderOptionsWithIcons;